import { Injectable } from "@angular/core";
import { HttpClientModule, HttpClient } from "@angular/common/http";
import { tap, catchError } from "rxjs/operators";
import { AuthResponseData } from "../auth-model/user.model";
import { throwError, BehaviorSubject } from "rxjs";
import { Router } from "@angular/router";
import { UrlModal } from "src/app/shared/url.model";

@Injectable({
  providedIn: "root"
})
export class AuthService {
  //  URL = "http://206.189.132.38:3005";
  //URL = "http://localhost:3005";

  authDataSubject = new BehaviorSubject<AuthResponseData>(null);

  constructor(private httpClient: HttpClient, private router: Router) {}

  loginhm(username: string, password: string) {
    console.log(password);
    return this.httpClient
      .post<User>(UrlModal._URL + "/ad/authadmin", {
        email: username,
        password: password
      })
      .pipe(
        tap(userRes => {
          console.log(userRes);
          const authResponse = new AuthResponseData(
            userRes.response.userData.id,
            userRes.response.token,
            userRes.response.userData.email,
            userRes.response.userData.userType
          );
          localStorage.setItem("authData", JSON.stringify(authResponse));
          this.autoLogin();
          this.authDataSubject.next(authResponse);
        }),
        catchError(errorRes => {
          let errorMessage = "An unknown error occured";
          switch (errorRes.error.message) {
            case "Email not found":
              errorMessage = "Username you entered doesn't match any account";
              break;
            case "Password did not match":
              errorMessage = "Password did not match";
              break;
          }
          return throwError(errorMessage);
        })
      );
  }
  autoLogin() {
    const authData: {
      id: string;
      token: string;

      email: string;
      userType: string;
    } = JSON.parse(localStorage.getItem("authData"));
    console.log(JSON.parse(localStorage.getItem("authData")));
    if (!authData) {
      return;
    }
    const loadedAuthData = new AuthResponseData(
      authData.id,
      authData.token,
      authData.email,
      authData.userType
    );
    if (authData.token) {
      this.authDataSubject.next(loadedAuthData);
    }
  }
  onLogout() {
    this.authDataSubject.next(null);
    localStorage.removeItem("authData");
    localStorage.clear();
    this.router.navigate(["/auth"]);
  }
}
export interface User {
  response: {
    token: string;
    userData: {
      token: string;
      id: string;
      email: string;
      userType: string;
    };
  };
}
